import { connect } from 'react-redux';

import DataSettings from './DataSettings';
import { actions as dataSettingsActions } from '../actions/dataSettingsDialog';
import { getSafeTimeBounds } from '../selectors/timeBounds';
import {
  getMetric,
  getTimespan,
  getCompare,
  getPrecision,
  getTotalCompareInterval,
  getTotalTimespanInterval,
  getAvailableCompare,
} from '../selectors/dataSettingsDialog';
import { isCensusView } from '../selectors/router';

export default connect(
  state => ({
    metric: getMetric(state),
    timespan: getTimespan(state),
    compare: getCompare(state),
    precision: getPrecision(state),
    compareInterval: getTotalCompareInterval(state),
    timespanInterval: getTotalTimespanInterval(state),
    censusView: isCensusView(state),

    timeBounds: getSafeTimeBounds(state),
    availableCompare: getAvailableCompare(state),
  }),
  {
    setMetric: dataSettingsActions.setMetric,
    setPrecision: dataSettingsActions.setPrecision,
    setCompare: dataSettingsActions.setCompare,
    setTimespan: dataSettingsActions.setTimespan,
    setCustomTimespanInterval: dataSettingsActions.setCustomTimespanInterval,
    setCustomCompareInterval: dataSettingsActions.setCustomCompareInterval,
  },
)(DataSettings);



// WEBPACK FOOTER //
// ./src/components/DataSettingsContainer.jsx